import { render, staticRenderFns } from "./TutorialesCaja.vue?vue&type=template&id=337fa839&scoped=true"
import script from "./TutorialesCaja.vue?vue&type=script&lang=js"
export * from "./TutorialesCaja.vue?vue&type=script&lang=js"
import style0 from "./TutorialesCaja.vue?vue&type=style&index=0&id=337fa839&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337fa839",
  null
  
)

export default component.exports